// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* P4a: Right Sidebar Dock (TradingView-style strip + panel) */
.ZaE38CINNV4WYPs9rkI9 {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: 100%;
  border-left: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-secondary, #111820);
  position: relative;
  z-index: 48;
  min-width: 150px;
  overflow: hidden;
  transition: width 0.18s ease;
}

/* Closed dock collapses to the strip — min-width must yield. */
.s0dyaEQgUIQWnTeo2OXp {
  min-width: 40px;
}

@media (max-width: 767px) {
  .ZaE38CINNV4WYPs9rkI9 {
    transition: none;
  }

  /* Closed sheet shrinks to the strip instead of an empty 45% bar. */
  .s0dyaEQgUIQWnTeo2OXp {
    height: auto;
    min-height: 0;
    border-top: none;
  }
}

.mIZ53rhUI3TBtYJhrukP {
  width: 4px;
  cursor: col-resize;
  z-index: 49;
  background: transparent;
  transition: background 0.2s;
  flex-shrink: 0;
}

.ZQ0QC8poi9Fj70lAgEGy {
  background: var(--vnsc-accent, #2962ff);
}

.oiGnTpCS0SBYKIe9AMbw {
  flex-shrink: 0;
  overflow-y: auto;
}

.PCZWANYGrVcYGIPXEzFk {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
}

._vGzNjR93ucOBYmkQxm9 {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.G8YwiRxYgy25ceo9htVC {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  border-bottom: 1px solid var(--vnsc-border-divider, #2a2a2a);
  flex-shrink: 0;
}

.BQ8McHGp2kvZfEbEGoQl {
  font-size: 11px;
  font-weight: 600;
  color: var(--vnsc-text-secondary, #787b86);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

/* F2: gom actions (pin + close) sát phải — single không pin nên X giữ nguyên vị trí.
   F3: gap 8px — pin sát X quá (2px) khó phân biệt khi thao tác nhanh. */
.dE3M6g6kHQPuFnn2bLrT {
  display: flex;
  align-items: center;
  gap: 8px;
}

.fqyRIXHwhwkGKWljC55P {
  background: transparent;
  border: none;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 2px;
  border-radius: 4px;
}

.fqyRIXHwhwkGKWljC55P:hover {
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
  color: var(--vnsc-text-primary, #d1d4dc);
}

.Fo5sXn03iw9QugPkOv83 {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.ymOmnaU_N2uf2dvwtzre {
  width: 40px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 6px 0;
  border-left: 1px solid var(--vnsc-border-divider, #2a2a2a);
  background: var(--vnsc-bg-primary, #131722);
  overflow-y: auto;
}

.FwEq4zpsn0LMwhNyKWme {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
}

.FwEq4zpsn0LMwhNyKWme:hover {
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
  color: var(--vnsc-text-primary, #d1d4dc);
}

/* Disabled tabs stay visible (discovery) but dimmed with reason tooltip. */
.p4kr645aXMJ5ax4mgCi_ {
  opacity: 0.38;
  cursor: not-allowed;
}

/* F-UI-04: dock/undock sits first on the rail (mirror drawing toolbar toggle);
   gap + flex-shrink keep it clickable when the strip scrolls. */
.qf2GRWAmD3qyYC5NohMi {
  margin-bottom: 4px;
  flex-shrink: 0;
}

/* D3: visible keyboard focus (strip is arrow-navigable). */
.FwEq4zpsn0LMwhNyKWme:focus {
  outline: none;
}

.FwEq4zpsn0LMwhNyKWme:focus-visible {
  outline: 2px solid var(--vnsc-accent-strong, #2563eb);
  outline-offset: -2px;
}

.kwhtn2UUfKhldVTYfTpa {
  background: var(--vnsc-bg-selected, rgba(59, 130, 246, 0.15));
  color: var(--vnsc-accent, #2962ff);
}

/* D4: mobile — dock becomes a bottom sheet instead of a 150px+40px side rail. */
@media (max-width: 767px) {
  .mIZ53rhUI3TBtYJhrukP {
    display: none;
  }

  .ZaE38CINNV4WYPs9rkI9 {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: auto;
    height: 45%;
    min-height: 220px;
    min-width: 0;
    width: auto !important;
    border-left: none;
    border-top: 1px solid var(--vnsc-border, #2a2a2a);
    /* W3 (C7): hạ về trần A12 ≤20 — dock sống trong overlay wrapper z-20. */
    z-index: 20;
  }

  .FwEq4zpsn0LMwhNyKWme {
    min-width: 44px;
    min-height: 44px;
  }

  .fqyRIXHwhwkGKWljC55P {
    min-width: 44px;
    min-height: 44px;
  }
}

.Nxoe0QWMl2Pv1QRUD8Yf {
  padding: 8px 10px;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

.PAef7qg_UuyphmjgSmZo {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.qVT3vvmV2B2lkWkXqYq8 {
  font-weight: 700;
  font-size: 13px;
  color: var(--vnsc-text-primary, #d1d4dc);
}

.cO0Ye01D845iPvAeZ8I8 {
  font-size: 10px;
  color: var(--vnsc-text-secondary, #787b86);
}

.iqTa5L_3yFHUUFVYdbou {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 0;
  border-bottom: 1px solid var(--vnsc-border-divider, #2a2a2a);
}

.iqTa5L_3yFHUUFVYdbou:last-child {
  border-bottom: none;
}

.zbD5sd7TSivu_fNPhLXe {
  color: var(--vnsc-text-secondary, #787b86);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 1;
}

.OUH6tW8nUXtFq0xNslnm {
  font-weight: 600;
  color: var(--vnsc-text-primary, #d1d4dc);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  flex-shrink: 0;
}

.pwgDEwaOKZGfzRlRk_jf {
  color: var(--vnsc-color-bullish, rgb(38, 166, 154));
}

.b_ckGlNT5pmvlSiM2ZXG {
  color: var(--vnsc-color-bearish, rgb(239, 83, 80));
}

.iFONvSpYUa2Bik841bH1 {
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px solid var(--vnsc-border-divider, #2a2a2a);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--vnsc-text-secondary, #787b86);
}

.hXwg3XzEf7aZ_V9fviJy {
  padding: 16px 12px;
  font-size: 12px;
  color: var(--vnsc-text-secondary, #787b86);
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/right-sidebar-dock.module.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,kDAAkD;EAClD,6CAA6C;EAC7C,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,+DAA+D;AAC/D;EACE,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA,mEAAmE;EACnE;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;wEACwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,0CAA0C;EAC1C,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2DAA2D;EAC3D,wCAAwC;AAC1C;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,0DAA0D;EAC1D,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,2DAA2D;EAC3D,wCAAwC;AAC1C;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;gEACgE;AAChE;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;AACf;;AAEA;EACE,qDAAqD;EACrD,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,kCAAkC;AACpC;;AAEA,gFAAgF;AAChF;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iDAAiD;IACjD,wEAAwE;IACxE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yDAAyD;EACzD,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;AACpB","sourcesContent":["/* P4a: Right Sidebar Dock (TradingView-style strip + panel) */\r\n.dock {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-shrink: 0;\r\n  height: 100%;\r\n  border-left: 1px solid var(--vnsc-border, #2a2a2a);\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  position: relative;\r\n  z-index: 48;\r\n  min-width: 150px;\r\n  overflow: hidden;\r\n  transition: width 0.18s ease;\r\n}\r\n\r\n/* Closed dock collapses to the strip — min-width must yield. */\r\n.dockClosed {\r\n  min-width: 40px;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .dock {\r\n    transition: none;\r\n  }\r\n\r\n  /* Closed sheet shrinks to the strip instead of an empty 45% bar. */\r\n  .dockClosed {\r\n    height: auto;\r\n    min-height: 0;\r\n    border-top: none;\r\n  }\r\n}\r\n\r\n.splitter {\r\n  width: 4px;\r\n  cursor: col-resize;\r\n  z-index: 49;\r\n  background: transparent;\r\n  transition: background 0.2s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.splitterActive {\r\n  background: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.stacked {\r\n  flex-shrink: 0;\r\n  overflow-y: auto;\r\n}\r\n\r\n.body {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n.panel {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.panelHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 6px 8px;\r\n  border-bottom: 1px solid var(--vnsc-border-divider, #2a2a2a);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.panelTitle {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n/* F2: gom actions (pin + close) sát phải — single không pin nên X giữ nguyên vị trí.\r\n   F3: gap 8px — pin sát X quá (2px) khó phân biệt khi thao tác nhanh. */\r\n.panelActions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.panelClose {\r\n  background: transparent;\r\n  border: none;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 2px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.panelClose:hover {\r\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n}\r\n\r\n.panelBody {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n}\r\n\r\n.strip {\r\n  width: 40px;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 2px;\r\n  padding: 6px 0;\r\n  border-left: 1px solid var(--vnsc-border-divider, #2a2a2a);\r\n  background: var(--vnsc-bg-primary, #131722);\r\n  overflow-y: auto;\r\n}\r\n\r\n.stripBtn {\r\n  width: 32px;\r\n  height: 32px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: transparent;\r\n  border: none;\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  cursor: pointer;\r\n}\r\n\r\n.stripBtn:hover {\r\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n}\r\n\r\n/* Disabled tabs stay visible (discovery) but dimmed with reason tooltip. */\r\n.stripBtnDisabled {\r\n  opacity: 0.38;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* F-UI-04: dock/undock sits first on the rail (mirror drawing toolbar toggle);\r\n   gap + flex-shrink keep it clickable when the strip scrolls. */\r\n.stripPin {\r\n  margin-bottom: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* D3: visible keyboard focus (strip is arrow-navigable). */\r\n.stripBtn:focus {\r\n  outline: none;\r\n}\r\n\r\n.stripBtn:focus-visible {\r\n  outline: 2px solid var(--vnsc-accent-strong, #2563eb);\r\n  outline-offset: -2px;\r\n}\r\n\r\n.stripBtnActive {\r\n  background: var(--vnsc-bg-selected, rgba(59, 130, 246, 0.15));\r\n  color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n/* D4: mobile — dock becomes a bottom sheet instead of a 150px+40px side rail. */\r\n@media (max-width: 767px) {\r\n  .splitter {\r\n    display: none;\r\n  }\r\n\r\n  .dock {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    top: auto;\r\n    height: 45%;\r\n    min-height: 220px;\r\n    min-width: 0;\r\n    width: auto !important;\r\n    border-left: none;\r\n    border-top: 1px solid var(--vnsc-border, #2a2a2a);\r\n    /* W3 (C7): hạ về trần A12 ≤20 — dock sống trong overlay wrapper z-20. */\r\n    z-index: 20;\r\n  }\r\n\r\n  .stripBtn {\r\n    min-width: 44px;\r\n    min-height: 44px;\r\n  }\r\n\r\n  .panelClose {\r\n    min-width: 44px;\r\n    min-height: 44px;\r\n  }\r\n}\r\n\r\n.dw {\r\n  padding: 8px 10px;\r\n  font-size: 12px;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.dwHead {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.dwSymbol {\r\n  font-weight: 700;\r\n  font-size: 13px;\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n}\r\n\r\n.dwTime {\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n}\r\n\r\n.dwRow {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 3px 0;\r\n  border-bottom: 1px solid var(--vnsc-border-divider, #2a2a2a);\r\n}\r\n\r\n.dwRow:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.dwLabel {\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  flex-shrink: 1;\r\n}\r\n\r\n.dwValue {\r\n  font-weight: 600;\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n  font-variant-numeric: tabular-nums;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.dwUp {\r\n  color: var(--vnsc-color-bullish, rgb(38, 166, 154));\r\n}\r\n\r\n.dwDown {\r\n  color: var(--vnsc-color-bearish, rgb(239, 83, 80));\r\n}\r\n\r\n.dwSection {\r\n  margin-top: 8px;\r\n  padding-top: 6px;\r\n  border-top: 1px solid var(--vnsc-border-divider, #2a2a2a);\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n}\r\n\r\n.dwEmpty {\r\n  padding: 16px 12px;\r\n  font-size: 12px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dock": `ZaE38CINNV4WYPs9rkI9`,
	"dockClosed": `s0dyaEQgUIQWnTeo2OXp`,
	"splitter": `mIZ53rhUI3TBtYJhrukP`,
	"splitterActive": `ZQ0QC8poi9Fj70lAgEGy`,
	"stacked": `oiGnTpCS0SBYKIe9AMbw`,
	"body": `PCZWANYGrVcYGIPXEzFk`,
	"panel": `_vGzNjR93ucOBYmkQxm9`,
	"panelHeader": `G8YwiRxYgy25ceo9htVC`,
	"panelTitle": `BQ8McHGp2kvZfEbEGoQl`,
	"panelActions": `dE3M6g6kHQPuFnn2bLrT`,
	"panelClose": `fqyRIXHwhwkGKWljC55P`,
	"panelBody": `Fo5sXn03iw9QugPkOv83`,
	"strip": `ymOmnaU_N2uf2dvwtzre`,
	"stripBtn": `FwEq4zpsn0LMwhNyKWme`,
	"stripBtnDisabled": `p4kr645aXMJ5ax4mgCi_`,
	"stripPin": `qf2GRWAmD3qyYC5NohMi`,
	"stripBtnActive": `kwhtn2UUfKhldVTYfTpa`,
	"dw": `Nxoe0QWMl2Pv1QRUD8Yf`,
	"dwHead": `PAef7qg_UuyphmjgSmZo`,
	"dwSymbol": `qVT3vvmV2B2lkWkXqYq8`,
	"dwTime": `cO0Ye01D845iPvAeZ8I8`,
	"dwRow": `iqTa5L_3yFHUUFVYdbou`,
	"dwLabel": `zbD5sd7TSivu_fNPhLXe`,
	"dwValue": `OUH6tW8nUXtFq0xNslnm`,
	"dwUp": `pwgDEwaOKZGfzRlRk_jf`,
	"dwDown": `b_ckGlNT5pmvlSiM2ZXG`,
	"dwSection": `iFONvSpYUa2Bik841bH1`,
	"dwEmpty": `hXwg3XzEf7aZ_V9fviJy`
};
export default ___CSS_LOADER_EXPORT___;
